<template>
  <div class="invoice-container">
    <!-- Fixed Header -->
    <header class="fixed-header">
      <div class="header-box">
        <div class="come-back" @click="goBack">←</div>
        <div class="title-box">Invoice</div>
        <div class="placeholder" />
      </div>
    </header>

    <!-- Main Content -->
    <div class="invoice-content">
      <!-- Contact Section -->
      <div class="contact-section">
        <h2 class="invoice-title">Invoice</h2>
        <div class="contact-info">
          <p class="contact-email">{{ customerInfo.email }}</p>
          <p class="contact-note">Invoice is about to be sent to your email</p>
        </div>
      </div>

      <!-- Invoice Details -->
      <div class="invoice-details">
        <div v-for="(detail, index) in invoiceDetails" :key="index" class="detail-row">
          <span class="detail-label">{{ detail.label }}</span>
          <span class="detail-value">{{ detail.value }}</span>
        </div>
      </div>

      <!-- Payment Section -->
      <div class="payment-section">
        <div class="payment-card">
          <div class="card-header">
            <h3 class="card-title">Payment Method</h3>
            <span class="card-status">{{ paymentInfo.status }}</span>
          </div>
          <div class="payment-info">
            <div class="payment-item">
              <span class="payment-label">Payment Type</span>
              <span class="payment-value">{{ paymentInfo.type }}</span>
            </div>
            <div class="payment-item">
              <span class="payment-label">Amount</span>
              <span class="payment-amount">¥{{ paymentInfo.amount }}</span>
            </div>
            <div class="payment-item">
              <span class="payment-label">Payment Date</span>
              <span class="payment-value">{{ paymentInfo.date }}</span>
            </div>
          </div>
        </div>

        <div class="pricing-summary">
          <div class="price-item">
            <span class="price-label">Original Price</span>
            <span class="price-value original">¥{{ pricingInfo.originalPrice }}</span>
          </div>
          <div class="price-item">
            <span class="price-label">Discount</span>
            <span class="price-value discount">-¥{{ pricingInfo.discount }}</span>
          </div>
          <div class="price-item total">
            <span class="price-label">Total</span>
            <span class="price-value total-amount">¥{{ pricingInfo.total }}</span>
          </div>
        </div>
      </div>

      <!-- Transactions Section -->
      <div class="transactions-section">
        <h3 class="section-title">Transaction History</h3>
        <div class="transaction-list">
          <div v-for="(transaction, index) in transactions" :key="index" class="transaction-item">
            <div class="transaction-info">
              <div class="transaction-date">{{ transaction.date }}</div>
              <div class="transaction-desc">{{ transaction.description }}</div>
            </div>
            <div class="transaction-amount">
              <span class="transaction-price">¥{{ transaction.amount }}</span>
              <span class="transaction-status" :class="transaction.status">
                {{ transaction.status }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="footer">
        <div class="footer-note">Customer service email</div>
        <div class="copyright">© 2025 Magicube Group Co., Limited.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BillingStatement',
  data() {
    return {
      customerInfo: {
        email: 'customer@example.com',
      },
      invoiceDetails: [
        { label: 'Order ID', value: 'ORD-202501120001' },
        { label: 'Invoice No', value: 'INV-202501120001' },
        { label: 'Date', value: '2025-01-12' },
        { label: 'Service', value: 'Magicube Platform Membership' },
        { label: 'Period', value: '2025-01-01 to 2025-01-31' },
      ],
      paymentInfo: {
        type: 'Auto Debit',
        amount: '299.00',
        date: '2025-01-10 14:30',
        status: 'Success',
      },
      pricingInfo: {
        originalPrice: '299.00',
        discount: '0.00',
        total: '299.00',
      },
      transactions: [
        {
          date: '2025-01-10',
          description: 'Magicube Platform Monthly Membership',
          amount: '299.00',
          status: 'Success',
        },
        {
          date: '2024-12-10',
          description: 'Magicube Platform Monthly Membership',
          amount: '299.00',
          status: 'Success',
        },
        {
          date: '2024-11-10',
          description: 'Magicube Platform Monthly Membership',
          amount: '299.00',
          status: 'Success',
        },
      ],
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.invoice-container {
  min-height: 100vh;
  background-color: #fff;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 44px;
  background-color: #fff;
  z-index: 999999;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.header-box {
  max-width: 768px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: space-between;
}

.come-back {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  color: #333;
}

.title-box {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.placeholder {
  width: 44px;
  flex-shrink: 0;
}

.invoice-content {
  padding-top: 54px;
  padding-bottom: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
  padding-left: 16px;
  padding-right: 16px;
}

.contact-section,
.invoice-details,
.payment-section,
.transactions-section {
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
}

.contact-section {
  padding: 20px;
}

.invoice-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
}

.contact-info {
  .contact-email {
    color: #ff1979;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .contact-note {
    color: #999;
    font-size: 13px;
    font-style: italic;
  }
}

.invoice-details {
  padding: 0;

  .detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }
  }

  .detail-label {
    color: #666;
    font-size: 14px;
    font-weight: 500;
  }

  .detail-value {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    text-align: right;
  }
}

.payment-section {
  padding: 0;

  .payment-card {
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .card-status {
    font-size: 12px;
    padding: 4px 12px;
    background-color: #e8f5e9;
    color: #2e7d32;
    border-radius: 12px;
  }

  .payment-info {
    .payment-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .payment-label {
      color: #666;
      font-size: 14px;
    }

    .payment-value {
      color: #333;
      font-size: 14px;
      font-weight: 500;
    }

    .payment-amount {
      color: #ff1979;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .pricing-summary {
    padding: 20px;
  }

  .price-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    &.total {
      margin-bottom: 0;
      padding-top: 12px;
      border-top: 1px solid #f0f0f0;
    }

    .price-label {
      color: #666;
      font-size: 14px;
    }

    .price-value {
      font-size: 14px;
      font-weight: 500;

      &.original {
        color: #666;
        text-decoration: line-through;
      }

      &.discount {
        color: #2e7d32;
      }

      &.total-amount {
        color: #212121;
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
}

.transactions-section {
  padding: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
}

.transaction-list {
  .transaction-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }
  }

  .transaction-info {
    flex: 1;

    .transaction-date {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 4px;
    }

    .transaction-desc {
      font-size: 13px;
      color: #666;
    }
  }

  .transaction-amount {
    text-align: right;
    margin-left: 16px;

    .transaction-price {
      display: block;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 4px;
    }

    .transaction-status {
      display: inline-block;
      font-size: 12px;
      padding: 2px 8px;
      border-radius: 8px;

      &.Success {
        background-color: #e8f5e9;
        color: #2e7d32;
      }
    }
  }
}

.footer {
  border-top: 1px solid #f0f0f0;
  margin-top: 24px;
  padding-top: 20px;
  text-align: center;
}

.footer-note {
  color: #666;
  font-size: 13px;
  margin-bottom: 8px;
}

.copyright {
  color: #999;
  font-size: 12px;
}

@media screen and (max-width: 768px) {
  .invoice-content {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
